import { IconProps } from '.';

function BadgeClock({ color, className }: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <title>BadgeClock</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M8 0C12.4185 0 16 3.58119 16 8C16 12.4188 12.4185 16 8 16C6.1193 16 4.33778 15.3485 2.91618 14.177C2.12814 13.5281 1.46819 12.7317 0.978304 11.8359C0.339742 10.6681 0 9.35779 0 8C0 3.58119 3.58152 0 8 0ZM8 1C4.13379 1 1 4.1335 1 8C1 9.1889 1.29701 10.3344 1.85569 11.3561C2.28424 12.1398 2.86206 12.8371 3.55198 13.4051C4.79626 14.4305 6.3535 15 8 15C11.8662 15 15 11.8665 15 8C15 4.1335 11.8662 1 8 1ZM8 3.5C8.27614 3.5 8.5 3.72386 8.5 4V7.9669L10.7572 9.32125C10.994 9.46333 11.0708 9.77046 10.9287 10.0072C10.7867 10.244 10.4795 10.3208 10.2428 10.1787L7.74275 8.67875C7.59215 8.58838 7.5 8.42563 7.5 8.25V4C7.5 3.72386 7.72386 3.5 8 3.5Z" fill={color} />
    </svg>
  );
}

export default BadgeClock;
